var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"region_compare_dis"},[_c('dec-block-title',[_vm._v("报警次数对比")]),_c('ul',[_c('li',[_c('dv-charts',{key:_vm.key,staticStyle:{"width":"300px","height":"300px"},attrs:{"option":_vm.option}}),_c('span',[_vm._v("报警次数对比")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }